export default __webpack_public_path__ + "static/media/users-three.47ec0709.svg";